<template>
    <div class="add_shop">
        <el-form  label-width="120px">
            <el-row>
                <el-col :lg="8">
                          <el-form-item label="職稱:">
                               <el-radio-group v-model="shopForm.brandId">
                                   <el-radio :label="1" >N牌</el-radio>
                                   <el-radio :label="2" >S牌</el-radio>
                               </el-radio-group>
                           </el-form-item>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="店櫃代碼:">
                        <el-input v-model="shopForm.shopId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8">
                    <el-form-item label="店櫃名稱:">
                        <el-input v-model="shopForm.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="店櫃電話:">
                        <el-input v-model="shopForm.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8">
                    <el-form-item label="店櫃傳真:">
                        <el-input v-model="shopForm.fax"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="區域:">
                        <el-input v-model="shopForm.area_note"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
            <el-row style="margin: 20px;">
                <el-col :lg="8">
                    <el-form-item label="平板設備ID:" >
                        <el-input v-model="device" style="width:70%;"></el-input>
                          <el-button type="primary" @click="addDevice">加入</el-button>
                    </el-form-item>
                  
                </el-col>
                <el-col :lg="8">
                     <el-table
                               :data="shopForm.device_id"
                               style="width: 100%"
                               size="small"
                               border
                               >
                               <el-table-column
                                   prop="device_id"
                                   label="平板設備ID:"
                                   width="auto"
                                   header-align="center"
                                   align="center">
                               </el-table-column>
                               <el-table-column label="刪除" align="center">
                                   <template slot-scope="scope">
                                       <el-button type="danger" icon="el-icon-delete" @click.native.prevent="deleteDevice(scope.$index, shopForm.device_id)"></el-button>
                                   </template>
                               </el-table-column>
                           </el-table>
                </el-col>
            </el-row>
            <el-row style="margin:20px;">
                <el-col :lg="24">
                    <el-form-item label="地址:" >
                               <el-select v-model="shopForm.city" placeholder="" @change="queryArea" >
                               <el-option v-for="item in getCityItems"
                                   :key="item.city"
                                   :label="item.city"
                                   :value="item.city">
                               </el-option>
                           </el-select>
                           <el-select v-model="shopForm.area" placeholder="" >
                               <el-option v-for="item in getAreaItems"
                                   :key="item.area"
                                   :label="item.area"
                                   :value="item.area">
                               </el-option>
                           </el-select>
                           
                               <el-input v-model="shopForm.address" style="width:50%;"></el-input>
                           
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="16">
                   <el-form-item label="簡介:">
                        <el-input type="textarea" v-model="shopForm.note" size="small" :rows="7"></el-input>
                   </el-form-item>
                </el-col>
              
            </el-row>
            <el-row type="flex" align="center">
                <el-col :lg="8">
                    <el-button type="primary" @click="addShop"><i class="el-icon-plus"></i>新增</el-button>
                    <el-button type="default" @click="back">返回</el-button>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
        </el-form>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
    export default {
        name: 'Add',
           data() {
            return {
                shopForm: {
                    brandId: 1,
                    name: '',
                    shopId: '',
                    tel: '',
                    fax: '',
                    area_note: '',
                    city: '',
                    area: '',
                    address: '',
                    device_id: [],
                        note: ''
                },
                device: ''
            }
        },
        computed: mapGetters(["getCityItems", "getAreaItems"]),
        methods: {
            ...mapActions(["fetchCity", "fetchArea", "addShop"]),
            addShop: function () {
              const data = {
                  brand_id: this.shopForm.brandId,
                  shop_id: this.shopForm.shopId,
                  name: this.shopForm.name,
                  tel: this.shopForm.tel,
                  fax: this.shopForm.fax,
                  area_note: this.shopForm.area_note,
                  city: this.shopForm.city,
                  area: this.shopForm.area,
                  address: this.shopForm.address,
                  device_id: this.shopForm.device_id,
                  note: this.shopForm.note
            }
             this.$store.dispatch('addShop', data)
             .then(() => {
                 this.$message('新增成功')
                 this.$emit('back')
             }).catch((err) => {
                 console.log(err);
             });
            
            },
             queryArea: function(){
          let city = this.shopForm.city
          let cityName = {city}
          this.$store.dispatch('fetchArea', cityName )
         },
         addDevice: function(){
             this.shopForm.device_id.push({
                 device_id: this.device
             })
             this.device = ''
         },
         back: function () {
             this.$emit('back')
         },
         deleteDevice(index, rows){
             rows.splice(index, 1)
         }
        },
        created() {
            this.fetchCity()
        },
    }
</script>

<style lang="scss" scoped>
    .add_shop {
        font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
</style>